export default "__VITE_ASSET__2a8a2d7e__"